import React from 'react';
import CardsContent from "./cards-content.jsx";
import StatusContent from "./status-content.jsx";
import TimelineContent from "./timeline-content.jsx";
import DetailsContent from "./details-content.jsx";

const ReportContent = ({ data, collapsed }) => {

    return (
        <>
            <CardsContent key={`cards-${collapsed}`} data={data}/>
            <StatusContent key={`status-${collapsed}`} data={data}/>
            <TimelineContent key={`timeline-${collapsed}`} data={data}/>
            <DetailsContent key={`details-${collapsed}`} data={data}/>

            <div id={'chart-tables'}/>
        </>
    );
};

export default ReportContent;